<template>
  <div class="app-select">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${options.componentKey}-${i}`"
        @click="removeError(i)"
        :class="{ 'child-has-error': error[i] }"
        class="input-group">
        <el-checkbox
          v-if = "options.name === 'Licenses' && options.descriptionforced"
          v-model="smartContractAgreement">
          <div class="smart-contract-agreement">
            {{ options.descriptionforced }}
          </div>
        </el-checkbox>

        <el-select
          :disabled="!smartContractAgreement"
          v-if="options.name === 'Licenses'"
          v-model="valueLocal[i]"
          :key="`app-select-opt-${i}`"
          :filterable="typeof options.filterable !== 'undefined' ? options.filterable : false"
          :clearable="typeof options.clearable !== 'undefined' ? options.clearable : true"
          @focus="removeError(i)"
          @visible-change="onVisibleChange"
          v-bind="widgetOptions">
          <el-option
            v-for="(label, value, i) in options.options"
            class="select-option license-option_lio"
            :key="`app-select-opt-option-${i}`"
            :label="label"
            :value="value">
            <img :src="licenses[value].icon" class="lio_icon">
            <div class="lio_label">{{ label }}</div>
            <div class="lio_desc">
              {{ options.optionsDescriptions[value] }}</div>
          </el-option>
        </el-select>

        <el-select
          v-else-if="options.options"
          v-model="valueLocal[i]"
          :key="`app-select-opt-${i}`"
          :filterable="typeof options.filterable !== 'undefined' ? options.filterable : false"
          :clearable="typeof options.clearable !== 'undefined' ? options.clearable : true"
          :multiple="typeof options.checkbox !== 'undefined' ? options.checkbox : false"
          @focus="removeError(i)"
          @visible-change="onVisibleChange"
          v-bind="widgetOptions">
          <el-option
            v-for="(label, value, i) in options.options"
            class="select-option"
            :key="`app-select-opt-option-${i}`"
            :label="label"
            :value="value"/>
        </el-select>

        <el-select
          v-else-if="options.vocabulary"
          v-model="valueLocal[i]"
          :key="`app-select-voc-${i}`"
          :filterable="typeof options.filterable !== 'undefined' ? options.filterable : true"
          :clearable="typeof options.clearable !== 'undefined' ? options.clearable : true"
          remote
          @focus="onFocus(i)"
          @visible-change="onVisibleChange"
          v-bind="widgetOptions"
          :remote-method="getSuggestions"
          :loading="loading">
          <el-option
            v-for="(s, j) in suggestions[i]"
            class="select-option"
            :key="`app-select-voc-option-${j}`"
            :label="s.value"
            :value="s.key"/>
        </el-select>

        <input-example
          :key="`input-example-${options.componentKey}-${i}`"
          :example="options.example"/>

        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import axios from 'axios';
import licenses from '@/data/licenses';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
      // Vocabulary powered select data
      loading: false,
      suggestions: [],
      curIndex: 0,
      licenses,
      smartContractAgreement: '',
    };
  },

  created() {
    this.validateMessages = Object.assign(
      this.validateMessages, {
        emptyAgreement: 'Необходимо согласие на предоставление доступа к объекту',
      },
    );
    if (!this.options.EditMode
      && this.options.defaultvalue
      && this.options.defaultvalue.length !== 0) {
      this.setValue(this.options.defaultvalue);
    }
    if (!this.options.componentKey) this.options.componentKey = 0;
    // Process custom local options of this widget type
    if (this.options.vocabulary) {
      this.widgetOptions.placeholder = 'Начинайте ввод...';
    } else {
      this.widgetOptions.placeholder = 'Выберите значение...';
    }
    if (this.options.placeholder) this.widgetOptions.placeholder = this.options.placeholder;
    if (this.options.name === 'Licenses' && this.options.descriptionforced) {
      this.smartContractAgreement = false;
    }
  },

  methods: {

    onFocus(i) {
      this.curIndex = i;
      this.removeError(i);
    },

    // Return errors array for all fields
    getError() {
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          if (this.options.name === 'LicensesTerms' && el.length === 0) {
            this.error[i] = this.validateMessages.required;
          } else if (this.options.name === 'Licenses' && !this.smartContractAgreement) {
            this.error[i] = this.validateMessages.emptyAgreement;
          } else if (!el) this.error[i] = this.validateMessages.required;
        });
      }
      this.updateValue();
      return this.error;
    },

    setValue(value) {
      if (this.options.vocabulary) {
        if (Array.isArray(value)) {
          if (value.length) {
            this.valueLocal = value;
          }
        } else {
          this.valueLocal = [value];
        }
        this.valueLocal.forEach((v, i) => {
          if (!v) return;
          axios.post('vocabularies/values', {
            voc: this.options.vocabulary, q: [v],
          }).then((r) => {
            this.suggestions[i] = [{ key: v, value: r.data[v] }];
            this.$forceUpdate();
          });
        });
      } else if (this.options.checkbox) {
        this.valueLocal = [value];
      } else if (Array.isArray(value)) {
        if (value.length) {
          this.valueLocal = value;
        }
      } else {
        const valueChecked = value !== null ? value : this.valueBase;
        this.valueLocal = [valueChecked];
        if (this.options.name === 'Licenses' && value) this.smartContractAgreement = true;
      }
      this.$forceUpdate();
    },

    getSuggestions(query) {
      if (query !== '') {
        this.loading = true;
        const params = { q: query, vocabulary: this.options.vocabulary };
        axios.get('vocabularies/suggest', { params }).then((response) => {
          this.loading = false;
          this.suggestions[this.curIndex] = response.data;
          this.$forceUpdate();
        });
      } else {
        this.suggestions[this.curIndex] = [];
        this.$forceUpdate();
      }
    },

    onVisibleChange(isVisible) {
      if (isVisible) {
        const width = this.$el.offsetWidth;
        document.querySelectorAll('.select-option').forEach((el) => {
          el.style.width = `${width}px`;
        });
      }
    },

  },

};
</script>

<style lang="scss">
.smart-contract-agreement {
  padding-bottom: 15px;
}
.el-input.is-disabled .el-input__inner,
.el-textarea.is-disabled .el-textarea__inner {
  background: rgba(0, 0, 0, 0.1);
}
.license-option_lio {
  position: relative;
  padding: 10px 20px 10px 70px !important;
  min-height: 75px;
  .lio_icon {
    position: absolute;
    left: 16px;
    top: 10px;
    width: 42px;
    height: auto;
    display: block;
  }
  .lio_label {
    font-weight: bold;
    line-height: 17px;
    margin-bottom: 5px;
  }
  .lio_desc {
    line-height: 17px;
  }
  @media (max-width: 550px) {
    padding: 10px 20px 10px 20px !important;
    .lio_icon {
      position: static;
      margin-right: 10px;
      float: left;
      width: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppSelect.vue